import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import styles from "./mobilerestaurantstatus.module.css";
import { IonLoading } from "@ionic/react";
import { ReactComponent as Trash } from "../../../src/svg/trash-can-regular.svg";
import { ReactComponent as CircleDollar } from "../../../src/svg/wallet-outline.svg";
import { ReactComponent as Ticket } from "../../../src/svg/ticket-regular.svg";

import { returnDayString } from "../etc/functions";
import { isDeadlinePassed } from "../../etc/regularmealdeadline";

import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

import { IonButton, useIonActionSheet } from '@ionic/react';
import { IonToast } from '@ionic/react';
import { IonModal } from "@ionic/react";
import InnerHeader from "../etc/innerheader";
import InnerHeaderForModal from "../etc/innerheaderformodal";

import TextField from '@mui/material/TextField';
import BottomButton from "../etc/bottomButton";
import { Skeleton } from "@mui/material";
import { dontNeedSunbaePayAcademies } from "../data/datas";



const MobileRestaurantStatus: React.FC<any> = (props) => {


    const [loading, setLoading] = useState(false);
    const topRef = useRef<any>(null);

    const [today, setToday] = useState(new Date());
    const [checkResult, setCheckResult] = useState([]);
    const [descriptionHeight, setDescriptionHeight] = useState(0);

    const [update, setUpdate] = useState(0);

    const [present] = useIonActionSheet();


    useEffect(() => {





        if (!topRef || !topRef.current || !props.statusDivHeight) {
            return;
        }

        const caculateBodyHeight = () => {



            if (!topRef || !topRef.current || !props.statusDivHeight) {
                return;
            }

            const totalHeight = props.statusDivHeight;
            const topHeight = topRef.current.offsetHeight;

            const descriptionHeight = totalHeight - topHeight - (2.469 * 16);





            setDescriptionHeight(descriptionHeight);
        }

        caculateBodyHeight();

        window.addEventListener("resize", caculateBodyHeight);

        return () => window.removeEventListener("resize", caculateBodyHeight);


    }, [topRef, props.statusDivHeight]);



    useEffect(() => {

        setLoading(true);

        const start = async () => {

            var token: any = "";

            if (Capacitor.isNativePlatform()) {
                const { value } = await Preferences.get({ key: "token" });
                token = value;
            }

            if (window.electron) {
                token = await window.electron.sendMessageApi.getToken();
            }

            fetch("https://peetsunbae.com/dashboard/restaurant/checkMobile", {
                method: "GET",
                headers: { "Authorization": token },
                credentials: "include",
            }).then((response: any) => {
                response.json()
                    .then((result: any) => {
                        if (result.message === "success") {
                            setCheckResult(result.totalData);
                            setLoading(false);
                        }
                    })
            }).catch((e: any) => {

                setLoading(false);
            })
        }

        start();

    }, [update]);


    const confirmDelete = (id: number, isRegular : any = false) => {
        present({
            header: "도시락 취소 안내",
            subHeader: "도시락 주문을 삭제할까요?",
            buttons: [{
                text: "삭제",
                role: "destructive"
            },
            {
                role: "cancel",
                text: "아니오",
            }
            ],
            onDidDismiss: ({ detail }) => {

                switch (detail.role) {
                    case "destructive":
                        deleteMeal(id, isRegular);
                        break;
                    case "cancel":
                        break;
                }
            },
        })
    }


    const deleteMeal = async (id: number, isRegular : any = false) => {

        if (!id) {
            alert("id가 없습니다");
            return;
        }

        setLoading(true);
        var token: any = "";

        if (window.electron) {
            token = window.electron.sendMessageApi.getToken();
        }

        if (Capacitor.isNativePlatform()) {
            const { value } = await Preferences.get({ key: "token" });
            token = value;
        }

        fetch("https://peetsunbae.com/dashboard/restaurant/check", {
            method: "DELETE",
            headers: { "Authorization": token, "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({
                id: id,
                isRegular : isRegular
            })
        }).then((response) => {
            response.json()
                .then((result) => {

                    if (result.message === "success") {
                        props.handleToastMessage2("🗑️ 도시락 주문 취소가 정상 처리되었습니다");
                        setUpdate(Math.random());
                        props.letsUpdate();
                    }
                    if (result.message === "TIME_OUT") {
                        props.handleToastMessage("🥵 환불 시간이 지났습니다");
                        setLoading(false);
                    }
                })
        }).catch((error) => {

        })

    }

    return (
        <div className={styles.statusBody}>
            <div className={styles.statusTop} ref={topRef}>
                <div className={styles.statusTitle}>
                    도시락 신청 현황
                </div>
                <div className={styles.statusNumber}>
                    {today.getMonth() + 1}월 {today.getDate()}일 {returnDayString(today.getDay())}요일 기준
                </div>
            </div>

            {
                loading
                &&
                <div style={{ width: "90.6%", margin: "0 auto" }}>
                    <div style={{ height: "20px" }}>
                    </div>
                    <Skeleton variant="rectangular" width="100%" height={140} />
                    <div style={{ height: "20px" }}>
                    </div>
                    <Skeleton variant="rectangular" width="100%" height={140} />
                    <div style={{ height: "20px" }}>
                    </div>
                    <Skeleton variant="rectangular" width="100%" height={140} />
                    <div style={{ height: "20px" }}>
                    </div>
                </div>
            }


            <div className={styles.description} style={{ height: `${descriptionHeight}px`, overflow: "scroll" }}>
                <div className={styles.descriptionBody}>
                    
                    {
                        (props.user && dontNeedSunbaePayAcademies().includes(props.user.academy)) ?
                            ""
                            :
                            <div className={`${styles.eachDescriptionBox} ${styles.cash}`}>
                                <div className={styles.iconDiv}>
                                    <CircleDollar fill="#304ffe" className={styles.circleDollar} />
                                </div>
                                <div className={styles.cashDescriptionDiv}>
                                    <div className={styles.cashDescription}>
                                        {props.isRegularMealMenuVisible ? "특식용 충전금 (선배페이)" : "충전금 잔액 (선배페이)"}
                                    </div>
                                    <div className={styles.cashTitle}>
                                        {props.chargedMoney !== undefined ? props.chargedMoney.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0}원
                                    </div>
                                </div>
                                <div className={styles.btnDiv} onClick={(e: any) => {
                                    props.handleCoinModalOpen();
                                }}>
                                    <div className={styles.cashBtn}>
                                        충전
                                    </div>
                                </div>
                            </div>
                    }


                    {
                        props.isRegularMealMenuVisible &&
                        <div className={`${styles.eachDescriptionBox} ${styles.cash}`}>
                            <div className={styles.iconDiv}>
                                <Ticket className={styles.circleDollar}
                                style={{
                                    transform : "rotate(-45deg)"
                                }}
                                />
                            </div>
                            <div className={styles.cashDescriptionDiv}>
                                <div className={styles.cashDescription}>
                                    정기식 식권
                                </div>
                                <div className={styles.cashTitle}>
                                    {props.chargedMealTicket}장
                                </div>
                            </div>
                            <div className={styles.btnDiv} onClick={(e: any) => {
                                props.handleMealTicketModalOpen();
                            }}>
                                <div className={styles.cashBtn}>
                                    구매
                                </div>
                            </div>
                        </div>
                    }



                    {
                        (checkResult && checkResult.length > 0) &&
                        checkResult.map((eachCheckResult: any, index: number) => {

                            const parentPermit = eachCheckResult.parentpermit;




                            const targetDate = new Date(eachCheckResult.targetDate);

                            var targetDateDay = returnDayString(targetDate.getDay());

                            const targetDateString = `${targetDate.getMonth() + 1}월 ${targetDate.getDate()}일 ${targetDateDay}요일 ${eachCheckResult.whenType === "lunch" ? "점심" : "저녁"}`;

                            return (
                                <div key={eachCheckResult.id}>
                                    <div className={`${styles.eachDescription} ${checkResult.length - 1 === index ? styles.last : ""}`}>
                                        <div className={styles.eachDescriptionDate}>
                                            {targetDateString}
                                        </div>
                                        <div className={styles.eachDescriptionBox}>
                                            <div className={styles.eachDescriptionText}>
                                                {eachCheckResult.restaurantName}
                                            </div>
                                            <div className={styles.eachDescriptionTargetDate}>
                                                {eachCheckResult.mealName}
                                            </div>
                                            <div className={styles.eachDescriptionKindDiv}>
                                                <div className={styles.eachDescriptionKindText}>
                                                    {eachCheckResult.isRegular ? "식권 " : ""}
                                                    {eachCheckResult.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    {eachCheckResult.isRegular ? "장" : "원"}
                                                </div>
                                            </div>
                                            {
                                                //정기식은 지점별 취소 마감이 지났으면 쓰레기통 숨김 (설정 없으면 기존대로 항상 노출, 서버 TIME_OUT이 최종 방어)
                                                (eachCheckResult.isRegular && props.regularMealSetting && props.regularMealSetting.deadlines &&
                                                    isDeadlinePassed(targetDate, eachCheckResult.whenType === "dinner" ? props.regularMealSetting.deadlines.cancelDinner : props.regularMealSetting.deadlines.cancelLunch)) ?
                                                    ""
                                                    :
                                                    <div className={styles.trashCanDiv} onClick={(e: any) => { confirmDelete(eachCheckResult.id, eachCheckResult.isRegular); }}>
                                                        <Trash fill="#251e1c" className={styles.trash} />
                                                    </div>
                                            }
                                        </div>
                                    </div>

                                </div>
                            );

                        })
                    }

                </div>
            </div>






            {/* <IonLoading
                cssClass='my-custom-class'
                isOpen={loading}
                onDidDismiss={() => setLoading(false)}
                message={'잠시만 기다려주세요'}
            /> */}


        </div>
    );
}

export default MobileRestaurantStatus;